import moment from "moment/moment";
import firebase from "firebase/app";
import {serializer} from "@/api/shared/serializer";
import ConfirmDlg from "@/components/popup/confirm-dialog/ConfirmDlg.vue";

export default {
  name: "contentEditDisplayEndDateDlg",
  data() {
    return {
      dialog: false,
      signage: null,
      signages: [],
      expirationDate: null,
      minDate: moment(new Date()).format("YYYY-MM-DD"),
      loading: false
    }
  },
  components: {
    ConfirmDlg
  },
  methods: {
    open(signage) {
      this.signage = signage;
      this.expirationDate = signage.expirationDate ?? this.minDate;
      this.dialog = true;
    },
    openForMultiple(signages) {
      this.signages = signages;
      this.expirationDate = this.minDate;
      this.dialog = true;
    },
    close() {
      this.dialog = false;
    },
    async save() {
      try {
        this.loading = true;

        if(this.signages.length) {
          const updates = this.signages.map(async (signage) => {
            const query = await firebase.firestore().collection("digitalSignage").doc(signage.digitalSignageId).get();
            if (query.exists) {
              const data: any = serializer.documentSnapshotToDocument(query);
              const pages = data.pages;

              if (this.expirationDate) {
                pages.forEach(page => {
                  if (page.contentCreatorId === signage.contentCreatorId) {
                    page.displayDate = true;
                    page.hasExpirationDate = true;
                    page.expirationDate = this.expirationDate;
                  }
                });

                await query.ref.update({ pages });

                this.$emit("setNewExpirationDate", signage, this.expirationDate);
              }
            }
          });

          await Promise.all(updates);

          this.$toast.open({
            message: this.$t("ContentPublishedToDlg.ContentUpdatedText"),
            type: 'success',
          });

          this.signages = [];
          this.$emit("clearSelectedSignages");
        } else {
          const query = await firebase.firestore().collection("digitalSignage").doc(this.signage.digitalSignageId).get();
          if (query.exists) {
            const data: any = serializer.documentSnapshotToDocument(query);
            const pages = data.pages;

            if (this.expirationDate) {
              pages.forEach(page => {
                if (page.contentCreatorId === this.signage.contentCreatorId) {
                  page.displayDate = true;
                  page.hasExpirationDate = true;
                  page.expirationDate = this.expirationDate;
                }
              });

              await query.ref.update({ pages });

              this.$toast.open({
                message: this.$t("ContentPublishedToDlg.ContentUpdatedText"),
                type: 'success',
              });

              this.$emit("setNewExpirationDate", this.signage, this.expirationDate);
            }
          }
        }

        await this.$store.dispatch("getDigitalSignages");
      } catch (err) {
        this.showError(err);
      } finally {
        this.close();
        this.loading = false;
      }
    },
    async remove() {
      try {
        const response = await this.$refs.confirmDlg.open(null, this.$t('ContentPublishedToDlg.ContentRemoveText'), false);
        if (!response || !response.agree) return;

        this.loading = true;

        if(this.signages.length) {
          const updates = this.signages.map(async (signage) => {
            const query = await firebase.firestore().collection("digitalSignage").doc(signage.digitalSignageId).get();
            if (query.exists) {
              const data: any = serializer.documentSnapshotToDocument(query);
              const pages = data.pages;

              pages.forEach(page => {
                if (page.contentCreatorId === signage.contentCreatorId) {
                  page.hasExpirationDate = false;
                }
              });

              await query.ref.update({ pages });
            }
          });

          await Promise.all(updates);

          this.$toast.open({
            message: this.$t("ContentPublishedToDlg.ContentUpdatedText"),
            type: 'success',
          });

          this.signages.forEach((x) => {
            x.hasExpirationDate = false;
          });
          this.signages = [];

          this.$emit("clearSelectedSignages");
        } else {
          const query = await firebase.firestore().collection("digitalSignage").doc(this.signage.digitalSignageId).get();
          if (query.exists) {
            const data: any = serializer.documentSnapshotToDocument(query);
            const pages = data.pages;

            pages.forEach(page => {
              if (page.contentCreatorId === this.signage.contentCreatorId) {
                page.hasExpirationDate = false;
              }
            });

            await query.ref.update({ pages });

            this.$toast.open({
              message: this.$t("ContentPublishedToDlg.ContentUpdatedText"),
              type: 'success',
            });
            this.signage.hasExpirationDate = false;
            this.$emit("clearSelectedSignages");
          }
        }

        await this.$store.dispatch("getDigitalSignages");
      } catch (err) {
        this.showError(err);
      } finally {
        this.close();
        this.loading = false;
      }
    },
    showError(err) {
      this.$toast.open({
        message: this.$t("GeneralTranslations.UnhandledError"),
        type: 'error',
      });
      console.log(err.message);
    }
  }
}